import React from "react";
import { FormattedMessage } from "react-intl";

type CountdownProps = {
    time: number;
};

type CountdownState = {
    time: number;
};

/**
 * Login component
 * @extends {React.Component}
 * Works in Login component
 */

export default class Countdown extends React.Component<CountdownProps, CountdownState> {
    private timer: any;

    constructor(props: CountdownProps) {
        super(props);
        this.timer = null;

        this.state = {
            time: this.props.time,
        };
    }

    componentDidMount() {
        this._startTimer();
    }

    componentWillUnmount() {
        clearInterval(this.timer);
        this.timer = null;
    }

    private _startTimer() {
        this.timer = setInterval(() => {
            this._countDown();
        }, 1000);
    }

    private _countDown() {
        let time = this.state.time - 1;
        this.setState({
            time: time,
        });
    }

    render() {
        return (
            <div>
                <FormattedMessage id="too_many_attempts_countdown" values={{ time: this.state.time }} />
            </div>
        );
    }
}
